import * as React from 'react'
import { Namespace, Container } from '@app/SecretManager/SecretsExplorer/model/repository'
import { VariablesTable } from '@app/SecretManager/SecretsExplorer/view/VariablesTable'
import { FilesTable } from '@app/SecretManager/SecretsExplorer/view/FilesTable'
import {
    Accordion,
    AccordionItem,
    AccordionContent,
    AccordionToggle,
} from '@patternfly/react-core';
import {
    ResourceItem,
    ResourceItemVariants,
    ResourceItemType
} from '@app/components/ResourceItem'
import {
    useParams,
    Link
} from 'react-router-dom'


const ContainerPage: React.FunctionComponent<{ namespaces: Namespace[], root: string }> = ({ namespaces, root }) => {

    const { namespace_name, application_name, container_name } = useParams<{ namespace_name: string, application_name: string, container_name: string }>();
    const namespace = namespaces.find(n => n.name === namespace_name);
    const application = namespace?.applications.find(a => a.name === application_name);
    const container = application?.containers?.find(c => c.name === container_name)
    if (container === undefined) {
        return <h1>Error</h1>
    }

    return (
        <>
            <section className="dx-page-section">
                <nav className="dx-breadcrumb">
                    <span className="dx-breadcrumb__item"><Link className="dx-breadcrumb__link" to={`${root}`}>Secret Manager</Link></span>
                    <span className="dx-breadcrumb__item"><Link className="dx-breadcrumb__link" to={`${root}/${namespace_name}`}>{namespace_name}</Link></span>
                    <span className="dx-breadcrumb__item"><Link className="dx-breadcrumb__link" to={`${root}/${namespace_name}/${application_name}`}>{application_name}</Link></span>
                    <span className="dx-breadcrumb__item">Container details</span>
                </nav>
                <ResourceItem variant={ResourceItemVariants.h1} type={ResourceItemType.Container}>{container.name}</ResourceItem>
            </section>
            <hr className="dx-divider" />
            <section className="dx-page-section">
                <h2 className="dx-title" style={{ marginBottom: '10px' }}>Variables</h2>
                <VariablesTable variables={container.secret_variables} root={root}/>
            </section>
            <hr className="dx-divider" />
            <section className="dx-page-section">
                <h3 className="dx-title" style={{ marginBottom: '10px' }}>Files</h3>
                <FilesTable files={container.secret_files} root={root}/>
            </section>
        </>

    )

}

export { ContainerPage }